// @ts-nocheck
/** Authentication state is held by a Secure, HttpOnly server cookie. */

export interface UserInfo {
  id: number;
  username: string;
  email: string;
  role: 'admin' | 'user';
  is_active: boolean;
}

let currentUser: UserInfo | null = null;

export const authUtils = {
  login(next: string = window.location.pathname + window.location.search): void {
    const safeNext = next.startsWith('/') && !next.startsWith('//') ? next : '/';
    window.location.assign(`/api/auth/oidc/login?next=${encodeURIComponent(safeNext)}`);
  },

  logout(): void {
    currentUser = null;
    window.location.assign('/api/auth/oidc/logout');
  },

  // Compatibility shims for components during the cookie-session migration.
  getToken(): null {
    return null;
  },

  getUser(): UserInfo | null {
    return currentUser;
  },

  isAdmin(): boolean {
    return currentUser?.role === 'admin';
  },

  isAuthenticated(): boolean {
    return false;
  },

  removeToken(): void {},
  removeUser(): void { currentUser = null; },
  setToken(_token?: string): void {},
  setUser(user?: UserInfo): void { currentUser = user || null; },
  saveLoginInfo(_token?: string, _user?: UserInfo): void {},
};

export default authUtils;
